import { constVoid } from './function.js';
import * as functor from './functor.js';
export * from 'fp-ts/Applicative';
export const when = (F) => (condition, fa) => 
// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
condition ? functor.asUnit(F)(fa()) : F.of(constVoid());
export const unless = (F) => (condition, fa) => when(F)(!condition, fa);
//# sourceMappingURL=applicative.js.map